import React from 'react';
import SEO from './SEO';

/**
 * Wraps a standalone /form page with its own title and noindex.
 * Form pages are not pre-rendered; Azure also sends an X-Robots-Tag noindex
 * header for /form/* (staticwebapp.config.json).
 */
const FormPage = ({ title, path, children }) => (
  <>
    <SEO
      title={`${title} | Clinical Minds Psychology`}
      description={`${title} for Clinical Minds Psychology.`}
      canonicalUrl={`https://www.clinicalminds.net/form/${path}`}
      noindex={true}
    />
    {children}
  </>
);

export default FormPage;
